// src/context/QueryProvider.jsx
// Wrap your App.jsx root with this (alongside your existing Provider/ModalProvider etc.)
//
// In App.jsx add:
//   import QueryProvider from './context/QueryProvider'
//   <QueryProvider> ... rest of providers ... </QueryProvider>

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,      // 2 min cache
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}